type GetTimeLeftFormattedParams =
  | { payingAllowedTill: string | Date }
  | { createdAt: string | Date; durationMinutes: number }

export const getTimeLeftFormatted = (params: GetTimeLeftFormattedParams): string => {
  let deadline: Date

  if ('payingAllowedTill' in params) {
    deadline = new Date(params.payingAllowedTill)
  } else {
    const created = new Date(params.createdAt)
    deadline = new Date(created.getTime() + params.durationMinutes * 60 * 1000)
  }

  const now = new Date()
  const diffMs = deadline.getTime() - now.getTime()

  if (diffMs <= 0) return '0 мин'

  const totalMinutes = Math.floor(diffMs / 1000 / 60)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  return hours > 0 ? `${hours} ч ${minutes} мин` : `${minutes} мин`
}
